import React from 'react';
import Input from 'components/Input';
import { withTranslation } from 'react-i18next';

export default withTranslation()(function ChangePasswordForm({t}) {

  const fields = [
    {
      name: 'old_password',
      label: t('settings.account_settings.current_pwd.label'),
      placeholder: t('settings.account_settings.current_pwd.placeholder'),
    },
    {
      name: 'new_password',
      label: t('settings.account_settings.new_pwd.label'),
      placeholder: t('settings.account_settings.new_pwd.placeholder'),
    },
    {
      name: 'new_password_confirmation',
      label: t('settings.account_settings.confirm_pwd.label'),
      placeholder: t('settings.account_settings.confirm_pwd.placeholder'),
    }
  ]
  return (
    <>
      {
        fields.map(({name, label, placeholder}) => {
          return (
            <div className="w-full mb-3" key={name}>
              <Input
                name={name}
                type="password"
                label={label}
                placeholder={placeholder}
                variant="filled"
              />
            </div>
          )
        })
      }
    </>
  )
})
